/**
 * Best-effort fetch of a field's latest **draft** value, to seed the editor when
 * an internal user clicks a scalar/html field (so they continue prior unpublished
 * edits). Off the critical path: any failure returns null and the caller falls
 * back to the on-page (published) text — editing still works. (AHD-7396)
 */
export async function seedCmsDraft(
  coords: { collection: string; id: string; field: string; locale: string },
  idToken: string,
  fetchImpl: typeof fetch = fetch
): Promise<string | null> {
  try {
    const qs = new URLSearchParams(coords)
    const res = await fetchImpl(`/api/edit/cms-field?${qs}`, {
      headers: { "User-Authorization": `Bearer ${idToken}` },
    })
    if (!res.ok) return null
    const { value } = (await res.json()) as { value: unknown }
    return typeof value === "string" ? value : null
  } catch {
    return null
  }
}
